export default "<div class=\"wrapper {{type}}\">\n  <div class=\"acronym\">FTSE</div>\n  <div class=\"name\">Russell</div>\n</div>\n"